const DB_NAME = "LogoDatabase";
const DB_VERSION = 1;
const STORE_NAME = "logos";

let dbInstance = null;

function openDb() {
  if (dbInstance) return Promise.resolve(dbInstance);
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "id" });
      }
    };

    request.onsuccess = () => {
      dbInstance = request.result;
      dbInstance.onclose = () => { dbInstance = null; };
      resolve(dbInstance);
    };
    request.onerror = () => reject(request.error);
  });
}

function executeTransaction(mode, callback) {
  return openDb().then((db) => {
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, mode);
      const store = transaction.objectStore(STORE_NAME);
      callback(store, resolve, reject);
      transaction.onerror = () => reject(transaction.error);
    });
  });
}

function getLogoById(id) {
  return executeTransaction("readonly", (store, resolve, reject) => {
    const request = store.get(id);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export function saveLogo(logo) {
  return executeTransaction("readwrite", (store, resolve, reject) => {
    const request = store.put(logo);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export function deleteAllLogos() {
  return executeTransaction("readwrite", (store, resolve, reject) => {
    const request = store.clear();
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
}

export async function getSrcLogoById(id, srcImgDefault) {
  try {
    const result = await getLogoById(id);
    if (result) return result.srcImg;
    return srcImgDefault;
  } catch (e) {
    return srcImgDefault;
  }
}

export function getLogosByIds(ids) {
  return executeTransaction("readonly", (store, resolve, reject) => {
    const results = {};
    let completed = 0;

    if (ids.length === 0) {
      resolve(results);
      return;
    }

    ids.forEach((id) => {
      const request = store.get(id);
      request.onsuccess = () => {
        if (request.result) {
          results[request.result.id] = request.result.srcImg;
        }
        completed++;
        if (completed === ids.length) {
          resolve(results);
        }
      };
      request.onerror = () => reject(request.error);
    });
  });
}
